import React from "react";
import './spinner.css';

const Spinner = () => {
    return (
        <div className="loadingio-spinner-spinner-hpxge166ora"><div className="ldio-5eb1y8sw73">
            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
        </div></div>
    )
}

export default Spinner;
